import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import CheckIcon from './CheckIcon'

interface PerksListProps {
  perks?: string
}

const PerksList = ({ perks }: PerksListProps) => (
  <Box className="flex flex-col gap-2" paddingRight="s16">
    {perks
      ?.split('. ')
      .filter(Boolean)
      .map((text, index) => (
        <Box key={index}>
          <Box flexDirection="row" alignItems="flexStart" gap="s8">
            <Box
              background="grey800"
              padding="s1"
              borderRadius={{ all: 'abs016' }}
              alignItems="center"
              style={{ marginTop: '4px' }}
            >
              <CheckIcon color="white" />
            </Box>
            <Text.Normal size="200">{text}</Text.Normal>
          </Box>
        </Box>
      ))}
  </Box>
)

export default PerksList
